import React from 'react';

export const CodeSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14.588 2.34a1 1 0 0 1 .707 1.225l-4.658 17.387a1 1 0 0 1-1.932-.518l4.659-17.386a1 1 0 0 1 1.224-.707M16.293 6.293a1 1 0 0 0 0 1.414L20.586 12l-4.293 4.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5a1 1 0 0 0-1.414 0M7.707 6.293a1 1 0 0 1 0 1.414L3.414 12l4.293 4.293a1 1 0 1 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0"
            clipRule="evenodd"
        />
    </svg>
);
